// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/burger/burger-menu.scss
 ** module id = 45
 ** module chunks = 0 1
 **/